/**
 * HHD Unit Toggle (US/EU) Custom Element
 * Handles unit switching in the product variant picker.
 * Refactored as a custom element to survive AJAX content updates.
 */
if (!customElements.get('hhd-unit-toggle')) {
  class HHDUnitToggle extends HTMLElement {
    constructor() {
      super();
      this.onToggleClick = this.onToggleClick.bind(this);
    }

    connectedCallback() {
      console.log('[HHD Unit Toggle] Connected');
      this.addEventListener('click', this.onToggleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onToggleClick);
    }

    onToggleClick(event) {
      const toggleBtn = event.target.closest('.hhd-size-toggle__btn');
      if (!toggleBtn) return;

      event.preventDefault();
      const unit = toggleBtn.dataset.unit; // "US" or "EU"

      // 1. Update active state of buttons within this toggle
      this.querySelectorAll('.hhd-size-toggle__btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.unit === unit);
      });

      // 2. Find the variant wrapper (fieldset/div) we belong to
      const wrapper = this.closest('.hhd-variant');
      if (!wrapper) return;

      // 3. Update all size button labels in this variant group
      wrapper.querySelectorAll('.hhd-variant-btn--size').forEach(label => {
        const value = label.dataset[unit.toLowerCase()]; // e.g. label.dataset.us
        if (value) {
          const textSpan = label.querySelector('.hhd-variant-btn-text');
          if (textSpan) {
            textSpan.textContent = value;
          }
        }
      });
    }
  }

  customElements.define('hhd-unit-toggle', HHDUnitToggle);
}
